import urlPrefix from "./apiPrefix";

export const getStatsErrorsTypes = () => `${urlPrefix.value}/tax-web-control/stats/errors/types`;
export const getStatsErrorsSummaryGroupByTin = () => `${urlPrefix.value}/tax-web-control/stats/errors/summary/group-by-tin`;
export const getStatsErrorsSummaryGroupByModel = () => `${urlPrefix.value}/tax-web-control/stats/errors/summary/group-by-model`;
export const getStatsErrorsCountersGroupByTin = () => `${urlPrefix.value}/tax-web-control/stats/errors/counters/group-by-tin`;
export const getStatsErrorsCountersGroupByTinCSV = () => `${urlPrefix.value}/tax-web-control/stats/errors/counters/group-by-tin/csv`;
export const getStatsErrorsCountersGroupByModel = () => `${urlPrefix.value}/tax-web-control/stats/errors/counters/group-by-model`;
